export default __webpack_public_path__ + "static/media/eyebrow.c3532837.svg";